module.exports = __webpack_public_path__ + "media/images/project/sort-new-4ed8cd94b384c1a02d15068be315d2ae.svg";